module.exports = __webpack_public_path__ + "static/media/LiteraEducational.06a7ec26.png";